import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

/**
 * Returns whether the current signed-in user has the 'admin' role.
 * Roles are stored in public.user_roles and validated via RLS.
 */
export const useIsAdmin = () => {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: ["is-admin", user?.id ?? "anon"],
    enabled: !!user,
    staleTime: 60_000,
    queryFn: async () => {
      if (!user) return false;
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id)
        .eq("role", "admin")
        .maybeSingle();
      if (error) {
        console.error("useIsAdmin error", error);
        return false;
      }
      return !!data;
    },
  });

  return {
    isAdmin: query.data === true,
    isLoading: query.isLoading,
  };
};
